/**
 * Complete list of countries and states/provinces
 * ISO 3166-1 alpha-2 country codes with subdivisions
 * Used for address forms, country selection, and regional data
 */

/** State/Province within a country */
export interface State {
  code: string
  name: string
}

/** Country with optional states/provinces */
export interface Country {
  code: string
  name: string
  states: readonly State[]
}

export const countries: readonly Country[] = [
  { code: 'AF', name: 'Afghanistan', states: [] },
  { code: 'AX', name: 'Aland Islands', states: [] },
  { code: 'AL', name: 'Albania', states: [] },
  { code: 'DZ', name: 'Algeria', states: [] },
  { code: 'AS', name: 'American Samoa', states: [] },
  { code: 'AD', name: 'Andorra', states: [] },
  { code: 'AO', name: 'Angola', states: [] },
  { code: 'AI', name: 'Anguilla', states: [] },
  { code: 'AQ', name: 'Antarctica', states: [] },
  { code: 'AG', name: 'Antigua And Barbuda', states: [] },
  { code: 'AR', name: 'Argentina', states: [] },
  { code: 'AM', name: 'Armenia', states: [] },
  { code: 'AW', name: 'Aruba', states: [] },
  { code: 'AU', name: 'Australia', states: [] },
  { code: 'AT', name: 'Austria', states: [] },
  { code: 'AZ', name: 'Azerbaijan', states: [] },
  { code: 'BS', name: 'Bahamas', states: [] },
  { code: 'BH', name: 'Bahrain', states: [] },
  { code: 'BD', name: 'Bangladesh', states: [] },
  { code: 'BB', name: 'Barbados', states: [] },
  { code: 'BY', name: 'Belarus', states: [] },
  { code: 'BE', name: 'Belgium', states: [] },
  { code: 'BZ', name: 'Belize', states: [] },
  { code: 'BJ', name: 'Benin', states: [] },
  { code: 'BM', name: 'Bermuda', states: [] },
  { code: 'BT', name: 'Bhutan', states: [] },
  { code: 'BO', name: 'Bolivia', states: [] },
  { code: 'BQ', name: 'Bonaire, Saint Eustatius and Saba', states: [] },
  { code: 'BA', name: 'Bosnia and Herzegovina', states: [] },
  { code: 'BW', name: 'Botswana', states: [] },
  { code: 'BV', name: 'Bouvet Island', states: [] },
  {
    code: 'BR',
    name: 'Brazil',
    states: [
      { code: 'AC', name: 'Acre' },
      { code: 'AL', name: 'Alagoas' },
      { code: 'AP', name: 'Amapá' },
      { code: 'AM', name: 'Amazonas' },
      { code: 'BA', name: 'Bahia' },
      { code: 'CE', name: 'Ceará' },
      { code: 'DF', name: 'Distrito Federal' },
      { code: 'ES', name: 'Espírito Santo' },
      { code: 'GO', name: 'Goiás' },
      { code: 'MA', name: 'Maranhão' },
      { code: 'MT', name: 'Mato Grosso' },
      { code: 'MS', name: 'Mato Grosso do Sul' },
      { code: 'MG', name: 'Minas Gerais' },
      { code: 'PR', name: 'Paraná' },
      { code: 'PB', name: 'Paraíba' },
      { code: 'PA', name: 'Pará' },
      { code: 'PE', name: 'Pernambuco' },
      { code: 'PI', name: 'Piauí' },
      { code: 'RN', name: 'Rio Grande do Norte' },
      { code: 'RS', name: 'Rio Grande do Sul' },
      { code: 'RJ', name: 'Rio de Janeiro' },
      { code: 'RO', name: 'Rondônia' },
      { code: 'RR', name: 'Roraima' },
      { code: 'SC', name: 'Santa Catarina' },
      { code: 'SE', name: 'Sergipe' },
      { code: 'SP', name: 'São Paulo' },
      { code: 'TO', name: 'Tocantins' },
    ],
  },
  { code: 'IO', name: 'British Indian Ocean Territory', states: [] },
  { code: 'BN', name: 'Brunei Darussalam', states: [] },
  { code: 'BG', name: 'Bulgaria', states: [] },
  { code: 'BF', name: 'Burkina Faso', states: [] },
  { code: 'BI', name: 'Burundi', states: [] },
  { code: 'KH', name: 'Cambodia', states: [] },
  { code: 'CM', name: 'Cameroon', states: [] },
  {
    code: 'CA',
    name: 'Canada',
    states: [
      { code: 'AB', name: 'Alberta' },
      { code: 'BC', name: 'British Columbia' },
      { code: 'MB', name: 'Manitoba' },
      { code: 'NB', name: 'New Brunswick' },
      { code: 'NL', name: 'Newfoundland and Labrador' },
      { code: 'NT', name: 'Northwest Territories' },
      { code: 'NS', name: 'Nova Scotia' },
      { code: 'NU', name: 'Nunavut' },
      { code: 'ON', name: 'Ontario' },
      { code: 'PE', name: 'Prince Edward Island' },
      { code: 'QC', name: 'Quebec' },
      { code: 'SK', name: 'Saskatchewan' },
      { code: 'YT', name: 'Yukon' },
    ],
  },
  { code: 'CV', name: 'Cape Verde', states: [] },
  { code: 'KY', name: 'Cayman Islands', states: [] },
  { code: 'CF', name: 'Central African Republic', states: [] },
  { code: 'TD', name: 'Chad', states: [] },
  { code: 'CL', name: 'Chile', states: [] },
  { code: 'CN', name: 'China', states: [] },
  { code: 'CX', name: 'Christmas Island', states: [] },
  { code: 'CC', name: 'Cocos (Keeling) Islands', states: [] },
  { code: 'CO', name: 'Colombia', states: [] },
  { code: 'KM', name: 'Comoros', states: [] },
  { code: 'CG', name: 'Congo', states: [] },
  { code: 'CD', name: 'Congo, the Democratic Republic of the', states: [] },
  { code: 'CK', name: 'Cook Islands', states: [] },
  { code: 'CR', name: 'Costa Rica', states: [] },
  { code: 'CI', name: "Cote d'Ivoire", states: [] },
  { code: 'HR', name: 'Croatia', states: [] },
  { code: 'CW', name: 'Curacao', states: [] },
  { code: 'CY', name: 'Cyprus', states: [] },
  { code: 'CZ', name: 'Czech Republic', states: [] },
  { code: 'DK', name: 'Denmark', states: [] },
  { code: 'DJ', name: 'Djibouti', states: [] },
  { code: 'DM', name: 'Dominica', states: [] },
  { code: 'DO', name: 'Dominican Republic', states: [] },
  { code: 'EC', name: 'Ecuador', states: [] },
  { code: 'SV', name: 'El Salvador', states: [] },
  { code: 'GQ', name: 'Equatorial Guinea', states: [] },
  { code: 'ER', name: 'Eritrea', states: [] },
  { code: 'EE', name: 'Estonia', states: [] },
  { code: 'ET', name: 'Ethiopia', states: [] },
  { code: 'FK', name: 'Falkland Islands (Malvinas)', states: [] },
  { code: 'FO', name: 'Faroe Islands', states: [] },
  { code: 'FJ', name: 'Fiji', states: [] },
  { code: 'FI', name: 'Finland', states: [] },
  { code: 'FR', name: 'France', states: [] },
  { code: 'GF', name: 'French Guiana', states: [] },
  { code: 'PF', name: 'French Polynesia', states: [] },
  { code: 'TF', name: 'French Southern Territories', states: [] },
  { code: 'GA', name: 'Gabon', states: [] },
  { code: 'GM', name: 'Gambia', states: [] },
  { code: 'GE', name: 'Georgia', states: [] },
  { code: 'DE', name: 'Germany', states: [] },
  { code: 'GH', name: 'Ghana', states: [] },
  { code: 'GI', name: 'Gibraltar', states: [] },
  { code: 'GR', name: 'Greece', states: [] },
  { code: 'GL', name: 'Greenland', states: [] },
  { code: 'GD', name: 'Grenada', states: [] },
  { code: 'GP', name: 'Guadeloupe', states: [] },
  { code: 'GU', name: 'Guam', states: [] },
  { code: 'GT', name: 'Guatemala', states: [] },
  { code: 'GG', name: 'Guernsey', states: [] },
  { code: 'GN', name: 'Guinea', states: [] },
  { code: 'GW', name: 'Guinea-Bissau', states: [] },
  { code: 'GY', name: 'Guyana', states: [] },
  { code: 'HT', name: 'Haiti', states: [] },
  { code: 'HM', name: 'Heard Island and McDonald Islands', states: [] },
  { code: 'VA', name: 'Holy See (Vatican City State)', states: [] },
  { code: 'HN', name: 'Honduras', states: [] },
  { code: 'HK', name: 'Hong Kong', states: [] },
  { code: 'HU', name: 'Hungary', states: [] },
  { code: 'IS', name: 'Iceland', states: [] },
  { code: 'IN', name: 'India', states: [] },
  { code: 'ID', name: 'Indonesia', states: [] },
  { code: 'IQ', name: 'Iraq', states: [] },
  { code: 'IE', name: 'Ireland', states: [] },
  { code: 'IM', name: 'Isle of Man', states: [] },
  { code: 'IL', name: 'Israel', states: [] },
  { code: 'IT', name: 'Italy', states: [] },
  { code: 'JM', name: 'Jamaica', states: [] },
  { code: 'JP', name: 'Japan', states: [] },
  { code: 'JE', name: 'Jersey', states: [] },
  { code: 'JO', name: 'Jordan', states: [] },
  { code: 'KZ', name: 'Kazakhstan', states: [] },
  { code: 'KI', name: 'Kiribati', states: [] },
  { code: 'KR', name: 'Korea, Republic of', states: [] },
  { code: 'XK', name: 'Kosovo', states: [] },
  { code: 'KW', name: 'Kuwait', states: [] },
  { code: 'KG', name: 'Kyrgyzstan', states: [] },
  { code: 'LA', name: "Lao People's Democratic Republic", states: [] },
  { code: 'LV', name: 'Latvia', states: [] },
  { code: 'LB', name: 'Lebanon', states: [] },
  { code: 'LS', name: 'Lesotho', states: [] },
  { code: 'LR', name: 'Liberia', states: [] },
  { code: 'LY', name: 'Libyan Arab Jamahiriya', states: [] },
  { code: 'LI', name: 'Liechtenstein', states: [] },
  { code: 'LT', name: 'Lithuania', states: [] },
  { code: 'LU', name: 'Luxembourg', states: [] },
  { code: 'MO', name: 'Macao', states: [] },
  { code: 'MK', name: 'Macedonia, the former Yugoslav Republic of', states: [] },
  { code: 'MG', name: 'Madagascar', states: [] },
  { code: 'MW', name: 'Malawi', states: [] },
  { code: 'MY', name: 'Malaysia', states: [] },
  { code: 'MV', name: 'Maldives', states: [] },
  { code: 'ML', name: 'Mali', states: [] },
  { code: 'MT', name: 'Malta', states: [] },
  { code: 'MH', name: 'Marshall Islands', states: [] },
  { code: 'MQ', name: 'Martinique', states: [] },
  { code: 'MR', name: 'Mauritania', states: [] },
  { code: 'MU', name: 'Mauritius', states: [] },
  { code: 'YT', name: 'Mayotte', states: [] },
  {
    code: 'MX',
    name: 'Mexico',
    states: [
      { code: 'AG', name: 'Aguascalientes' },
      { code: 'BN', name: 'Baja California' },
      { code: 'BS', name: 'Baja California Sur' },
      { code: 'CM', name: 'Campeche' },
      { code: 'CP', name: 'Chiapas' },
      { code: 'CH', name: 'Chihuahua' },
      { code: 'CA', name: 'Coahuila de Zaragoza' },
      { code: 'CL', name: 'Colima' },
      { code: 'DF', name: 'Distrito Federal' },
      { code: 'DU', name: 'Durango' },
      { code: 'GJ', name: 'Guanajuato' },
      { code: 'GR', name: 'Guerrero' },
      { code: 'HI', name: 'Hidalgo' },
      { code: 'JA', name: 'Jalisco' },
      { code: 'MC', name: 'Michoacán de Ocampo' },
      { code: 'MR', name: 'Morelos' },
      { code: 'MX', name: 'México' },
      { code: 'NA', name: 'Nayarit' },
      { code: 'NL', name: 'Nuevo León' },
      { code: 'OA', name: 'Oaxaca' },
      { code: 'PU', name: 'Puebla' },
      { code: 'QE', name: 'Querétaro de Arteaga' },
      { code: 'QR', name: 'Quintana Roo' },
      { code: 'SL', name: 'San Luis Potosí' },
      { code: 'SI', name: 'Sinaloa' },
      { code: 'SO', name: 'Sonora' },
      { code: 'TB', name: 'Tabasco' },
      { code: 'TM', name: 'Tamaulipas' },
      { code: 'TL', name: 'Tlaxcala' },
      { code: 'VE', name: 'Veracruz-Llave' },
      { code: 'YU', name: 'Yucatán' },
      { code: 'ZA', name: 'Zacatecas' },
    ],
  },
  { code: 'FM', name: 'Micronesia, Federated States of', states: [] },
  { code: 'MD', name: 'Moldova, Republic of', states: [] },
  { code: 'MC', name: 'Monaco', states: [] },
  { code: 'MN', name: 'Mongolia', states: [] },
  { code: 'ME', name: 'Montenegro', states: [] },
  { code: 'MS', name: 'Montserrat', states: [] },
  { code: 'MA', name: 'Morocco', states: [] },
  { code: 'MZ', name: 'Mozambique', states: [] },
  { code: 'MM', name: 'Myanmar', states: [] },
  { code: 'NA', name: 'Namibia', states: [] },
  { code: 'NR', name: 'Nauru', states: [] },
  { code: 'NP', name: 'Nepal', states: [] },
  { code: 'NL', name: 'Netherlands', states: [] },
  { code: 'NC', name: 'New Caledonia', states: [] },
  { code: 'NZ', name: 'New Zealand', states: [] },
  { code: 'NI', name: 'Nicaragua', states: [] },
  { code: 'NE', name: 'Niger', states: [] },
  { code: 'NU', name: 'Niue', states: [] },
  { code: 'NF', name: 'Norfolk Island', states: [] },
  { code: 'MP', name: 'Northern Mariana Islands', states: [] },
  { code: 'NO', name: 'Norway', states: [] },
  { code: 'OM', name: 'Oman', states: [] },
  { code: 'PK', name: 'Pakistan', states: [] },
  { code: 'PW', name: 'Palau', states: [] },
  { code: 'PS', name: 'Palestinian Territory, Occupied', states: [] },
  { code: 'PA', name: 'Panama', states: [] },
  { code: 'PG', name: 'Papua New Guinea', states: [] },
  { code: 'PY', name: 'Paraguay', states: [] },
  { code: 'PE', name: 'Peru', states: [] },
  { code: 'PH', name: 'Philippines', states: [] },
  { code: 'PN', name: 'Pitcairn', states: [] },
  { code: 'PL', name: 'Poland', states: [] },
  { code: 'PT', name: 'Portugal', states: [] },
  { code: 'PR', name: 'Puerto Rico', states: [] },
  { code: 'QA', name: 'Qatar', states: [] },
  { code: 'RE', name: 'Reunion', states: [] },
  { code: 'RO', name: 'Romania', states: [] },
  { code: 'RU', name: 'Russian Federation', states: [] },
  { code: 'RW', name: 'Rwanda', states: [] },
  { code: 'BL', name: 'Saint Barthelemy', states: [] },
  { code: 'SH', name: 'Saint Helena', states: [] },
  { code: 'KN', name: 'Saint Kitts and Nevis', states: [] },
  { code: 'LC', name: 'Saint Lucia', states: [] },
  { code: 'MF', name: 'Saint Martin (French part)', states: [] },
  { code: 'PM', name: 'Saint Pierre and Miquelon', states: [] },
  { code: 'VC', name: 'Saint Vincent and the Grenadines', states: [] },
  { code: 'WS', name: 'Samoa', states: [] },
  { code: 'SM', name: 'San Marino', states: [] },
  { code: 'ST', name: 'Sao Tome and Principe', states: [] },
  { code: 'SA', name: 'Saudi Arabia', states: [] },
  { code: 'SN', name: 'Senegal', states: [] },
  { code: 'RS', name: 'Serbia', states: [] },
  { code: 'SG', name: 'Singapore', states: [] },
  { code: 'SC', name: 'Seychelles', states: [] },
  { code: 'SL', name: 'Sierra Leone', states: [] },
  { code: 'SX', name: 'Sint Maarten', states: [] },
  { code: 'SK', name: 'Slovakia', states: [] },
  { code: 'SI', name: 'Slovenia', states: [] },
  { code: 'SB', name: 'Solomon Islands', states: [] },
  { code: 'SO', name: 'Somalia', states: [] },
  { code: 'ZA', name: 'South Africa', states: [] },
  { code: 'GS', name: 'South Georgia and the South Sandwich Islands', states: [] },
  { code: 'SS', name: 'South Sudan', states: [] },
  { code: 'ES', name: 'Spain', states: [] },
  { code: 'LK', name: 'Sri Lanka', states: [] },
  { code: 'SR', name: 'Suriname', states: [] },
  { code: 'SJ', name: 'Svalbard and Jan Mayen', states: [] },
  { code: 'SZ', name: 'Swaziland', states: [] },
  { code: 'SE', name: 'Sweden', states: [] },
  { code: 'CH', name: 'Switzerland', states: [] },
  { code: 'TW', name: 'Taiwan', states: [] },
  { code: 'TJ', name: 'Tajikistan', states: [] },
  { code: 'TH', name: 'Thailand', states: [] },
  { code: 'TL', name: 'Timor-Leste', states: [] },
  { code: 'TG', name: 'Togo', states: [] },
  { code: 'TK', name: 'Tokelau', states: [] },
  { code: 'TO', name: 'Tonga', states: [] },
  { code: 'TT', name: 'Trinidad and Tobago', states: [] },
  { code: 'TN', name: 'Tunisia', states: [] },
  { code: 'TR', name: 'Turkey', states: [] },
  { code: 'TM', name: 'Turkmenistan', states: [] },
  { code: 'TC', name: 'Turks and Caicos Islands', states: [] },
  { code: 'TV', name: 'Tuvalu', states: [] },
  { code: 'UA', name: 'Ukraine', states: [] },
  { code: 'AE', name: 'United Arab Emirates', states: [] },
  { code: 'GB', name: 'United Kingdom', states: [] },
  {
    code: 'US',
    name: 'United States',
    states: [
      { code: 'AL', name: 'Alabama' },
      { code: 'AK', name: 'Alaska' },
      { code: 'AZ', name: 'Arizona' },
      { code: 'AR', name: 'Arkansas' },
      { code: 'AE', name: 'Armed Forces' },
      { code: 'AA', name: 'Armed Forces America' },
      { code: 'AP', name: 'Armed Forces Pacific' },
      { code: 'CA', name: 'California' },
      { code: 'CO', name: 'Colorado' },
      { code: 'CT', name: 'Connecticut' },
      { code: 'DE', name: 'Delaware' },
      { code: 'FL', name: 'Florida' },
      { code: 'GA', name: 'Georgia' },
      { code: 'GU', name: 'Guam' },
      { code: 'HI', name: 'Hawaii' },
      { code: 'ID', name: 'Idaho' },
      { code: 'IL', name: 'Illinois' },
      { code: 'IN', name: 'Indiana' },
      { code: 'IA', name: 'Iowa' },
      { code: 'KS', name: 'Kansas' },
      { code: 'KY', name: 'Kentucky' },
      { code: 'LA', name: 'Louisiana' },
      { code: 'ME', name: 'Maine' },
      { code: 'MD', name: 'Maryland' },
      { code: 'MA', name: 'Massachusetts' },
      { code: 'MI', name: 'Michigan' },
      { code: 'MN', name: 'Minnesota' },
      { code: 'MS', name: 'Mississippi' },
      { code: 'MO', name: 'Missouri' },
      { code: 'MT', name: 'Montana' },
      { code: 'NE', name: 'Nebraska' },
      { code: 'NV', name: 'Nevada' },
      { code: 'NH', name: 'New Hampshire' },
      { code: 'NJ', name: 'New Jersey' },
      { code: 'NM', name: 'New Mexico' },
      { code: 'NY', name: 'New York' },
      { code: 'NC', name: 'North Carolina' },
      { code: 'ND', name: 'North Dakota' },
      { code: 'OH', name: 'Ohio' },
      { code: 'OK', name: 'Oklahoma' },
      { code: 'OR', name: 'Oregon' },
      { code: 'PA', name: 'Pennsylvania' },
      { code: 'PR', name: 'Puerto Rico' },
      { code: 'RI', name: 'Rhode Island' },
      { code: 'SC', name: 'South Carolina' },
      { code: 'SD', name: 'South Dakota' },
      { code: 'TN', name: 'Tennessee' },
      { code: 'TX', name: 'Texas' },
      { code: 'UT', name: 'Utah' },
      { code: 'VT', name: 'Vermont' },
      { code: 'VI', name: 'Virgin Islands' },
      { code: 'VA', name: 'Virginia' },
      { code: 'WA', name: 'Washington' },
      { code: 'DC', name: 'Washington DC' },
      { code: 'WV', name: 'West Virginia' },
      { code: 'WI', name: 'Wisconsin' },
      { code: 'WY', name: 'Wyoming' },
    ],
  },
  { code: 'UM', name: 'United States Minor Outlying Islands', states: [] },
  { code: 'UY', name: 'Uruguay', states: [] },
  { code: 'UZ', name: 'Uzbekistan', states: [] },
  { code: 'VU', name: 'Vanuatu', states: [] },
  { code: 'VE', name: 'Venezuela', states: [] },
  { code: 'VN', name: 'Viet Nam', states: [] },
  { code: 'VG', name: 'Virgin Islands, British', states: [] },
  { code: 'VI', name: 'Virgin Islands, U.S.', states: [] },
  { code: 'WF', name: 'Wallis and Futuna', states: [] },
  { code: 'EH', name: 'Western Sahara', states: [] },
  { code: 'YE', name: 'Yemen', states: [] },
  { code: 'ZM', name: 'Zambia', states: [] },
  { code: 'ZW', name: 'Zimbabwe', states: [] },
] as const

/** Union type of all country codes (ISO 3166-1 alpha-2) */
export type CountryCode = typeof countries[number]['code']
